import { createTheme } from '@mui/material/styles';

// disco-ui / sku-ui palette (mirrors src/sku-ui/color.scss)
const PRIMARY = '#19bf82';
const SUCCESS = '#19bf82';
const INFO = '#679fd9';
const WARNING = '#f5c022';
const ERROR = '#cf5151';

const theme = createTheme({
  palette: {
    primary: { main: PRIMARY, contrastText: '#ffffff' },
    success: { main: SUCCESS, contrastText: '#ffffff' },
    info: { main: INFO, contrastText: '#ffffff' },
    warning: { main: WARNING, contrastText: '#ffffff' },
    error: { main: ERROR, contrastText: '#ffffff' }
  }
});

export default theme;
